import { createContext } from "react";
import type { AttachmentsContext } from "./AttachmentsContext";

export const LocalAttachmentsContext = createContext<AttachmentsContext | null>(
  null
);
